/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Pitch_LabelInputs */

const en_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pitch`)
};

const fr_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas`)
};

const de_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tonhöhe`)
};

const it_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pece`)
};

const ru_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подача`)
};

const es_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paso`)
};

const zh_cn2_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沥青`)
};

const ja_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピッチ`)
};

const hi_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवाज़ का उतार-चढ़ाव`)
};

const pt_pt2_event_ad_pitch_label = /** @type {(inputs: Event_Ad_Pitch_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tom`)
};

/**
* | output |
* | --- |
* | "Pitch" |
*
* @param {Event_Ad_Pitch_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_pitch_label = /** @type {((inputs?: Event_Ad_Pitch_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Pitch_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_pitch_label(inputs)
	if (locale === "de") return de_event_ad_pitch_label(inputs)
	if (locale === "it") return it_event_ad_pitch_label(inputs)
	if (locale === "ru") return ru_event_ad_pitch_label(inputs)
	if (locale === "es") return es_event_ad_pitch_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_pitch_label(inputs)
	if (locale === "ja") return ja_event_ad_pitch_label(inputs)
	if (locale === "hi") return hi_event_ad_pitch_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_pitch_label(inputs)
	return en_event_ad_pitch_label(inputs)
});